module.exports = __webpack_public_path__ + "static/media/n3.92f8b4e8.png";